export enum WIDGET_TRAINING_LIST {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=804361128
     */
    SECTION_TITLE = 'WIDGET_TRAINING_LIST.SECTION_TITLE',
}
